import { render, staticRenderFns } from "./QualityControlRelatedListTable.vue?vue&type=template&id=ad7bc4da"
import script from "./QualityControlRelatedListTable.vue?vue&type=script&lang=js"
export * from "./QualityControlRelatedListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports